import { Field } from "react-final-form"
import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import MyTextField from "src/features/Components/TextField"
import React from "react"
import SearchIcon from "@material-ui/icons/Search"

// import styled from 'styled-components'

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 50,
  },
  textField: {
    width: "100%",
  },
}))

function Search({ type, onChangeType }) {
  const classes = useStyles()
  return (
    <Box display="flex" flexWrap="wrap" mt={1}>
      <Box mr={2} mb={1}>
        <Button
          size="small"
          color={type === "medicine" ? "secondary" : "default"}
          className={classes.button}
          variant="contained"
          disableElevation
          onClick={() => onChangeType("medicine")}
        >
          medicine
        </Button>
      </Box>
      <Box mr={2} mb={1}>
        <Button
          size="small"
          color={type === "supply" ? "secondary" : "default"}
          className={classes.button}
          variant="contained"
          disableElevation
          onClick={() => onChangeType("supply")}
        >
          supply
        </Button>
      </Box>
      <Box mr={2} mb={1}>
        <Button
          size="small"
          color={type === "bundle" ? "secondary" : "default"}
          className={classes.button}
          variant="contained"
          disableElevation
          onClick={() => onChangeType("bundle")}
        >
          Bundle
        </Button>
      </Box>
      <Box mr={2} mb={1}>
        <Field
          name="search_name"
          placeholder="Product Name"
          variant="outlined"
          component={MyTextField}
          className={classes.textField}
        />
      </Box>
      <Box>
        <Button
          size="small"
          color="primary"
          className={classes.button}
          variant="contained"
          disableElevation
          type="submit"
        >
          <SearchIcon />
        </Button>
      </Box>
    </Box>
  )
}

export default Search
